import(/* webpackMode: "eager" */ "/builds/magic.ai/frontend/magicsquare/apps/store-web/app/(v2)/components/ApplicationUserFeedback/ViewOneFeedbackItemDialog/internals/ViewOneFeedbackItemDialog.tsx");
